import type { User } from '../types/auth'

export const authStorageKeys = {
  accessToken: 'token',
  refreshToken: 'refresh_token',
  expiresAt: 'expires_at',
  user: 'auth_user',
  activeOrganizationId: 'active_organization_id',
} as const

// Ключи режима просмотра живут здесь же: logout обязан чистить и их, иначе
// бэкап суперадмин-сессии (с refresh-токеном) переживает выход и достаётся
// следующему пользователю браузера.
export const impersonationStorageKeys = {
  state: 'impersonation',
  adminBackup: 'impersonation_admin_backup',
} as const

export const getStoredAccessToken = (): string | null =>
  localStorage.getItem(authStorageKeys.accessToken)

export const setStoredAccessToken = (token: string): void => {
  localStorage.setItem(authStorageKeys.accessToken, token)
}

export const getStoredRefreshToken = (): string | null =>
  localStorage.getItem(authStorageKeys.refreshToken)

export const setStoredRefreshToken = (token: string): void => {
  localStorage.setItem(authStorageKeys.refreshToken, token)
}

export const getStoredExpiresAt = (): string | null =>
  localStorage.getItem(authStorageKeys.expiresAt)

export const setStoredExpiresAt = (expiresAt: string): void => {
  localStorage.setItem(authStorageKeys.expiresAt, expiresAt)
}

export const getStoredUser = (): User | null => {
  const rawUser = localStorage.getItem(authStorageKeys.user)
  if (!rawUser) {
    return null
  }

  try {
    return JSON.parse(rawUser) as User
  } catch {
    localStorage.removeItem(authStorageKeys.user)
    return null
  }
}

export const setStoredUser = (user: User): void => {
  localStorage.setItem(authStorageKeys.user, JSON.stringify(user))
}

export const removeStoredUser = (): void => {
  localStorage.removeItem(authStorageKeys.user)
}

export const getStoredActiveOrganizationId = (): string | null =>
  localStorage.getItem(authStorageKeys.activeOrganizationId)

export const setStoredActiveOrganizationId = (organizationId: string): void => {
  localStorage.setItem(authStorageKeys.activeOrganizationId, organizationId)
}

export const removeStoredActiveOrganizationId = (): void => {
  localStorage.removeItem(authStorageKeys.activeOrganizationId)
}

export const clearStoredAuthSession = (): void => {
  localStorage.removeItem(authStorageKeys.accessToken)
  localStorage.removeItem(authStorageKeys.refreshToken)
  localStorage.removeItem(authStorageKeys.expiresAt)
  localStorage.removeItem(authStorageKeys.user)
  localStorage.removeItem(authStorageKeys.activeOrganizationId)
  localStorage.removeItem(impersonationStorageKeys.state)
  localStorage.removeItem(impersonationStorageKeys.adminBackup)
}
